/************************************************************
 * Project: Book App
 * Author: Marcos Santos - A01072792
 * BCIT class Comp2913 - ReactJS by Daniel Takeuchi
 * Date: October, 10, 2020.
 * Description: Assignment - Book App
 * https://github.com/maasantos10/
 ************************************************************/

import axios from 'axios';

const api = axios.create({
  baseURL: 'https://www.googleapis.com/books',
  timeout: 8000,
  headers: {
                'Content-Type': 'application/json',
            }
});

export default api;
